import * as actionTypes from '../types'
import {updateObject} from '../../utils/utility'

const initialState = {
    payload: null,
    errors: null,
    isLoading: false,
    isSucceedForAdd: null,
    isSucceedForGetAll: null,
    isSucceedForGet: null,
    isSucceedForPut: null,
    isSucceedForDelete: null,
    isSucceedForGetByDepartmentId: null,
    isSucceedForUpdateStatus: null,
};
const addStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const addSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForAdd: action.isSucceedForAdd,
    });
};
const addFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const addReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForAdd: action.isSucceedForAdd,
    });
};
const getStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGet: action.isSucceedForGet,
    });
};
const getFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGet: action.isSucceedForGet,
    });
};
const getAllStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getAllSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const getAllFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getAllReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const putStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const putSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForPut: action.isSucceedForPut,
    });
};
const putFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const putReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForPut: action.isSucceedForPut,
    });
};
const getByDepartmentIdStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getByDepartmentIdSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetByDepartmentId: action.isSucceedForGetByDepartmentId,
    });
};
const getByDepartmentIdFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getByDepartmentIdReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetByDepartmentId: action.isSucceedForGetByDepartmentId,
    });
};
const updateStatusStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const updateStatusSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForUpdateStatus: action.isSucceedForUpdateStatus,
    });
};
const updateStatusFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const updateStatusReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForUpdateStatus: action.isSucceedForUpdateStatus,
    });
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_SUPPORT_START:
            return addStart(state,action);
        case actionTypes.ADD_SUPPORT_SUCCESS:
            return addSuccess(state,action);
        case actionTypes.ADD_SUPPORT_FAIL:
            return addFail(state,action);
        case actionTypes.ADD_SUPPORT_RESET:
            return addReset(state,action);
        case actionTypes.GET_SUPPORT_START:
            return getStart(state, action);
        case actionTypes.GET_SUPPORT_SUCCESS:
            return getSuccess(state, action);
        case actionTypes.GET_SUPPORT_FAIL:
            return getFail(state, action);
        case actionTypes.GET_SUPPORT_RESET:
            return getReset(state, action);
        case actionTypes.GET_ALL_SUPPORT_START:
            return getAllStart(state, action);
        case actionTypes.GET_ALL_SUPPORT_SUCCESS:
            return getAllSuccess(state, action);
        case actionTypes.GET_ALL_SUPPORT_FAIL:
            return getAllFail(state, action);
        case actionTypes.GET_ALL_SUPPORT_RESET:
            return getAllReset(state, action);
        case actionTypes.PUT_SUPPORT_START:
            return putStart(state, action);
        case actionTypes.PUT_SUPPORT_SUCCESS:
            return putSuccess(state, action);
        case actionTypes.PUT_SUPPORT_FAIL:
            return putFail(state, action);
        case actionTypes.PUT_SUPPORT_RESET:
            return putReset(state, action);
        case actionTypes.GET_SUPPORTS_BY_DEPARTMENT_ID_START:
            return getByDepartmentIdStart(state, action);
        case actionTypes.GET_SUPPORTS_BY_DEPARTMENT_ID_SUCCESS:
            return getByDepartmentIdSuccess(state, action);
        case actionTypes.GET_SUPPORTS_BY_DEPARTMENT_ID_FAIL:
            return getByDepartmentIdFail(state, action);
        case actionTypes.GET_SUPPORTS_BY_DEPARTMENT_ID_RESET:
            return getByDepartmentIdReset(state, action);
        case actionTypes.UPDATE_SUPPORT_STATUS_START:
            return updateStatusStart(state, action);
        case actionTypes.UPDATE_SUPPORT_STATUS_SUCCESS:
            return updateStatusSuccess(state, action);
        case actionTypes.UPDATE_SUPPORT_STATUS_FAIL:
            return updateStatusFail(state, action);
        case actionTypes.UPDATE_SUPPORT_STATUS_RESET:
            return updateStatusReset(state, action);
        default:
            return state;
    };
};

export default reducer;